import { render, staticRenderFns } from "./DetailsBreadcrumb.vue?vue&type=template&id=074797f4&"
import script from "./DetailsBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./DetailsBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports